import axios from 'axios'
const { VUE_APP_ETRAILS_API } = process.env

const loadEtrails = async (booking) => {
  const result = { error: false }
  try {
    const res = await axios.get(`${VUE_APP_ETRAILS_API}/etrails/vt/${booking}`)
    if (res && res.data) {
      result.data = res.data
      return res.data
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const loadEtrailCategories = async () => {
  const result = { error: false }
  try {
    const res = await axios.get(`${VUE_APP_ETRAILS_API}/etrail-categories/vt`)
    if (res && res.data) {
      result.data = res.data
      return res.data
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const sendClientResponseToEtrail = async (etrailId, payload) => {
  const result = { error: false }
  try {
    const res = await axios.patch(`${VUE_APP_ETRAILS_API}/etrails/client-response/${etrailId}`, payload)
    if (res && res.data) {
      result.data = res.data
      return res.data
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const markMessagesAsRead = async (etrailId, messageIds) => {
  const result = { error: false }
  try {
    const res = await axios.patch(`${VUE_APP_ETRAILS_API}/etrails/mark-messages-read/${etrailId}`, { messageIds })
    if (res && res.data) {
      result.data = res.data
      return res.data
    }
  } catch (err) {
    result.error = true
    return result
  }
}

export { loadEtrails, loadEtrailCategories, sendClientResponseToEtrail, markMessagesAsRead }
